
export const GET_CART_REQUEST="GET_CART_REQUEST"
export const GET_CART_SUCCESS="GET_CART_SUCCESS"
export const GET_CART_FAILURE="GET_CART_FAILURE"

export const POST_CART_SUCESS="POST_CART_SUCESS"

export const DELETE_CART_SUCCESS = "DELETE_CART_SUCCESS";
